import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { getBookingById } from "../../../api/services";

type Props = {
    bookingId: string;
    depositType: string;
    depositAmount: number;
    preautAmount: number;
}

export async function updateRceDeposit(props: Props) {
    const bookingDetails = await getBookingById(props.bookingId);

    const resp = await axios.post("/booking/rce-dashoboard/v1/update-rce-deposit", {
        ...props,
        id: 0,
        idRentalAgreement: bookingDetails.rentalAgreement,
        tenant: bookingDetails.tenant,
        dealer: bookingDetails.dealer,
        depositType: props.depositType === "BANK_TRASFER" ? "PREAUTHORIZATION" : "BANK_TRASFER",
        depositAmount: props.depositType === "BANK_TRASFER" ? props.depositAmount : props.preautAmount,
        depositStatus: "NOT_YET_SETTLED",
        preautAmount: props.depositType === "BANK_TRASFER" ? props.depositAmount : props.preautAmount,
        lastDepositType: props.depositType,
        customerId: bookingDetails.customerCode,
    });
    return resp.data;
}

export function useRceDepositMutation() {
    const mutation = useMutation(updateRceDeposit);
    return mutation;
}
